<template>
  <div>
    <div class="d-lg-none">
      <div class="row">
        <div class="col-12 col-sm-6" v-for="r in resources.data" :key="'mobile-' + r.id">
          <bs-card class="card-info mt-2" :label="''">
            <template v-slot:header>
            </template>
            <div class="p-2">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <small><b>{{ r.created_at | luxon }}</b><br>
                  <span class="text-muted">{{ r.created_at | luxon:diffForHumans }}</span></small><br>
                </div>
                <div><b>{{ $n(r.amount, 'currency') }}</b></div>
              </div>
              <div class="pt-2">{{ r.description }}</div>
            </div>
            <template v-slot:footer>
              <div class="py-1 px-2 d-flex justify-content-between">
                <div>
                  <span v-if="r.budget_id" class="badge badge-pill badge-warning">{{ find(budgets, 'id', r.budget_id, 'label') }}</span>
                  <span v-else class="badge badge-pill badge-primary">{{ find(funds, 'id', r.fund_id, 'label') }}</span>
                  <span v-for="tag in r.tags" :key="'r' + r.id + 't' + tag.id" :class="'badge badge-pill bg-' + tag.color">{{ tag.label }}</span>
                </div>
                <div>
                  <bs-action :icon="['fal', 'check']" class="mr-1" :class="selected.includes(r.id) ? 'btn-success' : 'btn-info'" @click="select(r)"></bs-action>
                  <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info mr-1" @click="update(r)"></bs-action>
                  <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
                </div>
              </div>
            </template>
          </bs-card>
        </div>
      </div>
    </div>
    <bs-card class="card-info d-none d-lg-block" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="7">
        <template v-slot:thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">{{ $t('labels.date') }}</th>
            <th scope="col">{{ $tc('labels.budget', 1) }} / {{ $tc('labels.fund', 1) }}</th>
            <th scope="col">{{ $tc('labels.tag', 0) }}</th>
            <th scope="col">{{ $t('labels.description') }}</th>
            <th scope="col">{{ $t('labels.amount') }}</th>
            <th scope="col"></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td class="t1 text-left">
            <bs-action :icon="['fal', 'check']" :class="selected.includes(r.id) ? 'btn-success' : 'btn-info'" @click="select(r)"></bs-action>
          </td>
          <td>{{ r.created_at | luxon }}</td>
          <td>
            <span v-if="r.budget_id" class="badge badge-pill badge-warning">{{ find(budgets, 'id', r.budget_id, 'label') }}</span>
            <span v-else class="badge badge-pill badge-primary">{{ find(funds, 'id', r.fund_id, 'label') }}</span>
          </td>
          <td>
            <span v-for="tag in r.tags" :key="'r' + r.id + 't' + tag.id" :class="'badge badge-pill bg-' + tag.color">{{ tag.label }}</span>
          </td>
          <td>{{ r.description }}</td>
          <td>{{ $n(r.amount, 'currency') }}</td>
          <td class="t2">
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="slotProps.error"></input-field>
          <input-field :type="'float'" :name="'amount'" :label="$t('labels.amount')" v-model="resource.amount" :error="slotProps.error"></input-field>
          <select-field v-if="!resource.fund_id" :name="'budget'" :label="$tc('labels.budget', 1)" v-model="resource.budget_id" :error="slotProps.error">
            <option :value="0"></option>
            <option v-for="budget in budgets" :key="'b' + budget.id" :value="budget.id">{{ budget.label }}</option>
          </select-field>
          <select-field v-if="!resource.budget_id" :name="'fund'" :label="$tc('labels.fund', 1)" v-model="resource.fund_id" :error="slotProps.error">
            <option :value="0"></option>
            <option v-for="fund in funds" :key="'f' + fund.id" :value="fund.id">{{ fund.label }}</option>
          </select-field>
          <div class="form-group bs-form-group">
            <label class="typo__label text-uppercase">{{ $tc('labels.tag', {}, 0) }}</label>
            <multiselect v-model="resource.tags"
                         :options="tags"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         :showLabels="false"
                         label="label"
                         :placeholder="$t('labels.please_select')"
                         track-by="id">
            </multiselect>
          </div>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
    <portal to="app-footer">
      <pagination :data="resources" :state="resourceState" @pushPage="index" :filters="filters"></pagination>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Transactions',
  mixins: [resourceControl],
  components: {
    Multiselect
  },
  data () {
    return {
      icon: ['fal', 'books'],
      resource: {
        description: '',
        amount: null,
        budget_id: null,
        fund_id: null,
        tags: {}
      },
      filters: {
        after: true,
        budget: true,
        fund: true,
        tag: true
      },
      selected: []
    }
  },
  computed: {
    ...mapState({
      resources: state => state.transactions,
      resourceState: state => state.transactionsState,
      budgets: state => state.budgetsStore,
      funds: state => state.fundsStore,
      tags: state => state.tagsStore
    }),
    selectedTotal () {
      let total = 0
      if (this.selected.length === 0) {
        this.resources.data.forEach((r) => {
          total += r.amount
        })
      } else {
        this.selected.forEach((id) => {
          const transaction = this._.find(this.resources.data, ['id', id])
          total += transaction.amount
        })
      }
      return total
    }
  },
  watch: {
    selectedTotal (newVal) {
      this.$emit('displayTotal', newVal)
    }
  },
  methods: {
    select (r) {
      if (this.selected.includes(r.id)) {
        const index = this.selected.indexOf(r.id)
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      } else {
        this.selected.push(r.id)
      }
    }
  }
}
</script>
